import { render, staticRenderFns } from "./skeletonVideo.vue?vue&type=template&id=ef01d0ac&scoped=true"
var script = {}
import style0 from "./skeletonVideo.vue?vue&type=style&index=0&id=ef01d0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef01d0ac",
  null
  
)

export default component.exports